import { BLOCKS } from '@contentful/rich-text-types'
import { withDisplayName } from '@hocs/with-display-name'
import { MainCta } from '@layouts/main-cta'
import { paragraph } from '@render-node/paragraph'
import { documentHeading1 } from '@render-node/refresh-document-heading-1'
import { children } from '@render-node/utils/children'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { Container } from '@ui/container'
import { ErrorMappingMsg } from '@ui/error-boundary'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import { useErrorBoundary } from 'react-error-boundary'

const ContentfulPageImageTitleRefreshInformational: Utils.EntryFC<
  Queries.ContentfulPageImageTitleRefreshInformationalFragment
> = ({
  content: {
    unusedImage,
    unusedBackgroundImage,
    unusedOfferRef,
    headline,
    subHeadline,
    informationalBackgroundImage,
  },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const { showBoundary } = useErrorBoundary()

  if (unusedImage || unusedBackgroundImage || unusedOfferRef) {
    showBoundary({
      code: ErrorMappingMsg.ErrorContentfulInformationalPageModel,
    })
  }

  return (
    <div
      className="group/hero is-informational-hero relative flex h-full w-full items-center justify-center"
      {...entryInspectorProps()}
    >
      {informationalBackgroundImage && (
        <GatsbyImage
          alt={informationalBackgroundImage.description}
          className="h-[550px] w-full object-cover tablet:object-fill"
          image={getImage(informationalBackgroundImage)}
          loading="eager"
        />
      )}
      <Container className="absolute flex flex-col items-center justify-center text-center laptop:max-w-[976px]">
        <RichText
          className="text-balance"
          {...fieldInspectorProps({
            fieldId: 'headline',
          })}
          content={headline}
          options={{
            renderNode: {
              [BLOCKS.DOCUMENT]: documentHeading1,
              [BLOCKS.PARAGRAPH]: children,
            },
          }}
        />
        {subHeadline && (
          <RichText
            {...fieldInspectorProps({
              fieldId: 'subHeadline',
            })}
            content={subHeadline}
            options={{
              ...defaultRichTextFieldOptionsDeprecated,
              renderNode: {
                ...defaultRichTextFieldOptionsDeprecated.renderNode,
                [BLOCKS.PARAGRAPH]: paragraph,
              },
            }}
          />
        )}
        <div className="w-full">
          <MainCta />
        </div>
      </Container>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPageImageTitleRefreshInformational on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    headline {
      rich
    }
    subHeadline {
      rich
    }
    unusedImage: image {
      ...Asset
    }
    unusedBackgroundImage: backgroundImage {
      ...Asset
    }
    unusedOfferRef: offerRef {
      ...ContentfulOfferRefresh
    }
    informationalBackgroundImage {
      ...Asset
      gatsbyImageData(layout: FULL_WIDTH, formats: [AVIF, WEBP, AUTO])
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitleRefreshInformational,
  'ContentfulPageImageTitleRefreshInformational'
)
